import React from 'react';

// Import components
import { useContextProvider } from 'components/views/vod/components/PlayerWrapper/useContextProvider';
import { Button } from 'components/elements';
import Setting from './Setting';
import {
	Container,
	Tooltip,
	TooltipContent,
	Bg,
	IconSettings,
	IconTriangle
} from './styles';

// Import utilities
import { usePlayerSettings } from 'components/utilities';

const SettingsController = () => {
	const { player } = useContextProvider();

	const {
		tracks,
		profiles,
		selectedTrack,
		selectedLanguage,
		subtitles,
		selectedSubtitle,
		setSelectedTrack,
		setAudioLanguage,
		setSelectedSubtitle
	} = usePlayerSettings(player);

	return (
		<Container>
			<Button modifiers={['icon', 'playerIconHover']}>
				<IconSettings />
			</Button>

			<Tooltip>
				<Bg />
				<IconTriangle />

				<TooltipContent>
					<Setting
						name="player_settings_language"
						data={tracks}
						selected={selectedLanguage}
						onSelect={setAudioLanguage}
						minLength={2}
					/>
					<Setting
						name="player_settings_subtitles"
						data={subtitles}
						selected={selectedSubtitle}
						onSelect={setSelectedSubtitle}
						minLength={2}
					/>
					<Setting
						name="player_settings_profiles"
						data={profiles}
						selected={selectedTrack}
						onSelect={setSelectedTrack}
					/>
				</TooltipContent>
			</Tooltip>
		</Container>
	);
};

export default SettingsController;
